export default __webpack_public_path__ + "static/media/GR00007-origami_owl.d03c5ab0.svg";